import styled from "styled-components/macro";
import { PrimaryButton } from "@loanbossinc/component-library";
import { IconButton } from "@material-ui/core";

export const StyledPropertySelectWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1em;
  border-bottom: 1px solid #dadce0;
  min-height: 80px;
  box-sizing: border-box;
`;

export const StyledSelectButton = styled(PrimaryButton)`
  width: 121px !important;
  height: 36px !important;
  background-color: #005aa9 !important;
  font-size: 14px !important;
`;

export const StyledIconButton = styled(IconButton)`
  && {
    width: 18px !important;
    padding: 0;
    background: none;
    border: none;
    margin-right: 2em;
  }

  &:hover {
    background: none !important;
  }
`;
